<template>
  <div class="container col-md-12">
    <h1>Social Retirement Taxes Calc</h1>
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>
    <div v-if="calcData">
      <hr />
      <h3>Result</h3>
      <md-content>
        <md-content class="md-padding">
          <table class="table table-striped table-bordered">
            <tr>
              <th>State</th>
              <th>Code</th>
              <th>Age Limit Lower</th>
              <th>Age Limit Upper</th>
              <th>Income Limit</th>
              <th>Exemption Lower Age</th>
              <th>Exemption Upper Age</th>
              <th>TF LDI Fund A</th>
              <th>TF LDI Fund B</th>
              <th>TF LDI Fund C</th>
              <th>TF LDI Fund D</th>
              <th>TF LDI Fund E</th>
              <th>Exemption LDI Fund A</th>
              <th>Exemption LDI Fund B</th>
              <th>Exemption LDI Fund C</th>
              <th>Exemption LDI Fund D</th>
              <th>Exemption LDI Fund E</th>
            </tr>
            <tr v-for="row in calcData">
              <td>{{ row.state_retirement_tax.state }}</td>
              <td>{{ row.state_retirement_tax.state_code }}</td>
              <td>{{ row.state_retirement_tax.age_limit_lower }}</td>
              <td>{{ row.state_retirement_tax.age_limit_upper }}</td>
              <td>{{ row.state_retirement_tax.income_limit }}</td>
              <td>{{ row.state_retirement_tax.exemption_lower_age }}</td>
              <td>{{ row.state_retirement_tax.exemption_upper_age }}</td>
              <td>{{ row.tax_factor.ldi_a | numeral("0.1") }}%</td>
              <td>{{ row.tax_factor.ldi_b | numeral("0.1") }}%</td>
              <td>{{ row.tax_factor.ldi_c | numeral("0.1") }}%</td>
              <td>{{ row.tax_factor.ldi_d | numeral("0.1") }}%</td>
              <td>{{ row.tax_factor.ldi_e | numeral("0.1") }}%</td>
              <td>{{ row.exemption.ldi_a | currency }}</td>
              <td>{{ row.exemption.ldi_b | currency }}</td>
              <td>{{ row.exemption.ldi_c | currency }}</td>
              <td>{{ row.exemption.ldi_d | currency }}</td>
              <td>{{ row.exemption.ldi_e | currency }}</td>
            </tr>
          </table>
        </md-content>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import {
  CALC_STATE_RETIREMENT_TAXES,
  CALC_RESET_STATE
} from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";
export default {
  data() {
    return {
      calcAction: CALC_STATE_RETIREMENT_TAXES,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT_BALANCE,
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
